import { Component, Inject, OnInit, QueryList, Self, ViewChild, ViewChildren } from '@angular/core';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../utils/utils';
import { takeUntil } from 'rxjs';
import { DestroyService } from '../../../services/destroyservice';
import { MatDialog } from '@angular/material/dialog';
import { EmtTdcDeploymentStatusPopup } from '../emttdcdeployment/emttdc-deploymentstatus-popup.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TextFilterField } from '../../shared/text-filter-bar/text-filter-bar.component';

@Component({
    selector: 'softwarereleases',
    templateUrl: './softwarereleases.component.html',
    styleUrls: ['./softwarereleases.component.less', '../../../style/new-generic-styles.component.less'],
    providers: [DestroyService],
    standalone: false
})
export class SoftwareReleasesComponent implements OnInit {
    availableComponentFunctions: ComponentFunction[] = [];
    availableFamilyCodes: FamilyCode[] = [];
    availableProductUsages: EMTProductUsageItem[] = [];
    availableCenters: MfgCenter[] = [];
    availableCenterProducts: MFGCenterProductItem[] = [];
    availableControllerSoftwareReleases: EMTControllerSoftwareReleaseItem[] = [];
    originalSoftwareReleases: EMTControllerSoftwareReleaseItem[] = [];

    subscriptionStage: any;
    @ViewChildren(MatTab)
    tabs!: QueryList<MatTab>;
    @ViewChild('tabGroup')
    tabGroup!: MatTabGroup;
    availableLanguages: Language[] = [];

    peripheralBoardFilter: string = '';
    peripheralFamilyCodeFilter: string = '';

    peripheralFilterFields: TextFilterField[] = [
        { key: 'board', label: 'Board', value: '' },
        { key: 'familyCode', label: 'Family Code', value: '' }
    ];

    onPeripheralFilterChange(values: { [key: string]: string }) {
        this.peripheralBoardFilter = values['board'] ?? '';
        this.peripheralFamilyCodeFilter = values['familyCode'] ?? '';
    }

    constructor(private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , @Self() private readonly destroy$: DestroyService
        , private matDialog: MatDialog) { }

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.getFamilyCodes()
            this.getProductsUsage();
            this.getSoftwareReleases();
        });
        this.getFamilyCodes();
        this.getMFGCenters();
        this.getProductsUsage();
        this.getAvailableLanguages();
        this.getSoftwareReleases();
    }

    getFamilyCodes() {
        Utils.httpGetComponentFamilyCodes(
            this.http,
            this.baseUrl,
            this,
            function(tthis: SoftwareReleasesComponent, result: ComponentFamilyCodes) {
                tthis.availableFamilyCodes = result.familyCodeList;
            }
        );
    }

    getMFGCenters() {
        Utils.httpGetMfgcenters(this.http,
            this.baseUrl,
            this,
            function(tthis: SoftwareReleasesComponent, result: MfgCenters) {
                tthis.availableCenters = result.centersList;
            }
        );
    }

    getProductsUsage() {
        Utils.httpGetEMTProductsUsage(
            this.http,
            this.baseUrl,
            this,
            function(tthis: SoftwareReleasesComponent, result: EMTProductsUsage) {
                tthis.availableProductUsages = result.usagesList;
            }
        );
    }

    loadCenterProduct(centerProduct: MFGCenterProductItem[]) {
        this.availableCenterProducts = centerProduct;
    }

    loadControllerSoftware(controllerSoftware: EMTControllerSoftwareReleaseItem[]) {
        this.availableControllerSoftwareReleases = controllerSoftware;
    }

    openDeploymentInformationPopup() {
        this.matDialog.open(EmtTdcDeploymentStatusPopup, {
            panelClass: 'custom-mat-dialog',
            data: { "component": 'emttdc' }
        });
    }

    isSoftwareReleaseToFieldSelected() {
        return Number.isInteger(this.tabGroup?.selectedIndex)
            && this.tabs.get(this.tabGroup.selectedIndex!)?.textLabel === 'Software Release to Field';
    }

    getAvailableLanguages() {
        Utils.httpGetAllLanguages(
            this.http
            , this.baseUrl
            , this
            , function(tthis: SoftwareReleasesComponent, values: Language[]) {
                tthis.availableLanguages = values;
            }           
        );
    }

    loadCompFunctions(compFunctions: ComponentFunction[]) {
        this.availableComponentFunctions = compFunctions;
    }

    loadFamilyCodes(familyCodes: FamilyCode[]) {
        this.availableFamilyCodes = familyCodes;
    }

    getSoftwareReleases() {
        Utils.httpGetEMTControllerSoftwareReleases(
            this.http,
            this.baseUrl,
            undefined,
            this,
            function(tthis: SoftwareReleasesComponent, result: EMTControllerSoftwareReleases) {
                tthis.originalSoftwareReleases = result.releasesList;
            }
        );
    }
}
